import { render, staticRenderFns } from "./proudce.vue?vue&type=template&id=b2f298a8&scoped=true&"
import script from "./proudce.vue?vue&type=script&lang=js&"
export * from "./proudce.vue?vue&type=script&lang=js&"
import style0 from "./proudce.vue?vue&type=style&index=0&id=b2f298a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f298a8",
  null
  
)

export default component.exports